import { Action, createAction, handleActions } from "redux-actions";
import moment from "moment";
import { queueMessage } from "~shared/snackbarsProvider/actions";
import {
  GetCoberturasCompaniaResponse,
  GetPolizaResponse,
  PostRenovarPolizaRequest,
  PostRenovarPolizaResponse,
} from "~api/types";
import {
  CampoRenovacion,
  CuotaRenovacion,
  Dispatch,
  FechaRenovacion,
  GetState,
  RenovacionPolizaState,
  ServicesRenovacion,
} from "../types";

const setSubmitting = createAction("SET_SUBMITTING", (submitting: boolean) => ({
  submitting,
}));

const setCurrentPoliza = createAction(
  "SET_CURRENT_USUARIO",
  (currentPoliza: GetPolizaResponse | null) => ({
    currentPoliza,
  })
);

const getPolizaInited = createAction("OBTENER_POLIZA_RENOVAR_INITED");

const getPolizaCompleted = createAction(
  "OBTENER_POLIZA_RENOVAR_COMPLETED",
  (currentPoliza: GetPolizaResponse) => ({ currentPoliza })
);

const getPolizaFailed = createAction(
  "OBTENER_POLIZA_RENOVAR_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getCoberturasInited = createAction("OBTENER_COBERTURAS_INITED");

const getCoberturasCompleted = createAction(
  "OBTENER_COBERTURAS_COMPLETED",
  (coberturas: GetCoberturasCompaniaResponse) => ({ coberturas })
);

const getCoberturasFailed = createAction(
  "OBTENER_COBERTURAS_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getCoberturas = (compania: string, negocio: string) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesRenovacion
  ) => {
    try {
      dispatch(getCoberturasInited());

      const response = await services.api
        .esquemas()
        .getCoberturas(compania, negocio);

      dispatch(getCoberturasCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getCoberturasFailed(error));
    }
  };
};

const setPremioTotal = createAction(
  "SET_PREMIO_TOTAL",
  (premioTotalSelected: CampoRenovacion<string | number | null>) => ({
    premioTotalSelected,
  })
);

const setVigenciaDesde = createAction(
  "SET_VIGENCIA_DESDE",
  (vigenciaDesdeSelected: CampoRenovacion<FechaRenovacion>) => ({
    vigenciaDesdeSelected,
  })
);
const setVigenciaHasta = createAction(
  "SET_VIGENCIA_HASTA",
  (vigenciaHastaSelected: CampoRenovacion<FechaRenovacion>) => ({
    vigenciaHastaSelected,
  })
);

const setSumaAsegurada = createAction(
  "SET_SUMA_ASEGURADA",
  (sumaAseguradaSelected: CampoRenovacion<string | number | null>) => ({
    sumaAseguradaSelected,
  })
);

const setVigencia = createAction(
  "SET_VIGENCIA",
  (vigenciaSelected: CampoRenovacion<number>) => ({
    vigenciaSelected,
  })
);

const setCantidadCuotas = createAction(
  "SET_CANTIDAD_CUOTAS",
  (cantidadCuotasSelected: CampoRenovacion<number>) => ({
    cantidadCuotasSelected,
  })
);

const setCobertura = createAction(
  "SET_COBERTURA",
  (coberturaSelected: CampoRenovacion<string>) => ({
    coberturaSelected,
  })
);

const setNumeroPoliza = createAction(
  "SET_NUMERO_POLIZA",
  (numeroPolizaSelected: CampoRenovacion<string | null>) => ({
    numeroPolizaSelected,
  })
);

const setPolizaFileName = createAction(
  "SET_POLIZA_FILENAME",
  (polizaFileNameSelected: CampoRenovacion<string | null>) => ({
    polizaFileNameSelected,
  })
);
const setTarjetaFileName = createAction(
  "SET_TARJETA_FILENAME",
  (tarjetaFileNameSelected: CampoRenovacion<string | null>) => ({
    tarjetaFileNameSelected,
  })
);

const setCedulaMercosurFileName = createAction(
  "SET_CEDULA_MERCOSUR_FILENAME",
  (cedulaMercosurFileNameSelected: CampoRenovacion<string | null>) => ({
    cedulaMercosurFileNameSelected,
  })
);

const setCuponeraFileName = createAction(
  "SET_CUPONERA_FILENAME",
  (cuponeraFileNameSelected: CampoRenovacion<string | null>) => ({
    cuponeraFileNameSelected,
  })
);

const setIsProcessingPoliza = createAction(
  "SET_PROCESSING_POLIZA",
  (isProcessingPoliza: boolean) => ({
    isProcessingPoliza,
  })
);
const setIsProcessingTarjeta = createAction(
  "SET_PROCESSING_TARJETA",
  (isProcessingTarjeta: boolean) => ({
    isProcessingTarjeta,
  })
);
const setIsProcessingCedulaMercosur = createAction(
  "SET_PROCESSING_CEDULA_MERCOSUR",
  (isProcessingCedulaMercosur: boolean) => ({
    isProcessingCedulaMercosur,
  })
);
const setIsProcessingCuponera = createAction(
  "SET_PROCESSING_CUPONERA",
  (isProcessingCuponera: boolean) => ({
    isProcessingCuponera,
  })
);

const getPoliza = (id: string) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesRenovacion
  ) => {
    try {
      dispatch(getPolizaInited());
      const response = await services.api.polizas().getPoliza(id);

      dispatch(getPolizaCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getPolizaFailed(error));
    }
  };
};

const postRenovarPolizaInited = createAction("PROCESAR_RENOVAR_POLIZA_INITED");
const postRenovarPolizaCompleted = createAction(
  "PROCESAR_RENOVAR_POLIZA_COMPLETED",
  (response: PostRenovarPolizaResponse) => {}
);
const postRenovarPolizaFailed = createAction(
  "PROCESAR_RENOVAR_POLIZA_FAILED",
  (error: unknown) => ({
    error,
  })
);

const postRenovarPoliza = (
  polizaId: string,
  data: PostRenovarPolizaRequest
) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesRenovacion
  ) => {
    try {
      dispatch(postRenovarPolizaInited());

      const response = await services.api
        .polizas()
        .postRenovarPoliza(polizaId, data);

      dispatch(postRenovarPolizaCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(postRenovarPolizaFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al renovar la póliza. Intente nuevamente."
        )
      );
    }
  };
};

const postValidatePolizaInited = createAction(
  "PROCESAR_VALIDATE_POLIZA_INITED"
);
const postValidatePolizaCompleted = createAction(
  "PROCESAR_VALIDATE_POLIZA_COMPLETED",
  (response: Response) => {}
);
const postValidatePolizaFailed = createAction(
  "PROCESAR_VALIDATE_POLIZA_FAILED",
  (error: unknown) => ({
    error,
  })
);

const setCuota = createAction(
  "SET_CUOTA_RENOVACION",
  (cuotaSelected: CuotaRenovacion) => ({
    cuotaSelected,
  })
);

const clearCuotas = createAction("CLEAR_CUOTAS_RENOVACION", () => ({}));

const clearData = createAction("CLEAR_DATA_RENOVACION", () => ({}));

const postValidatePoliza = (polizaId: string) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesRenovacion
  ) => {
    try {
      dispatch(postValidatePolizaInited());

      const response = await services.api
        .polizas()
        .postValidatePolizaARenovar(polizaId);

      dispatch(postValidatePolizaCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(postValidatePolizaFailed(error));
    }
  };
};

const renovacionPolizaInitialState: RenovacionPolizaState = {
  currentPoliza: null,
  isLoading: true,
  failed: false,

  numeroPolizaSelected: { value: "", valid: false, focus: false },
  vigenciaDesdeSelected: { value: new Date(), valid: true, focus: false },
  vigenciaHastaSelected: { value: new Date(), valid: false, focus: false },
  vigenciaSelected: { value: 6, valid: true },
  cantidadCuotasSelected: { value: 6, valid: true },
  sumaAseguradaSelected: { value: 0, valid: false, focus: false },
  premioTotalSelected: { value: 0, valid: false, focus: false },
  coberturaSelected: { value: "", valid: false },
  coberturasOptions: null,
  coberturasFilter: [],
  cuotasSelected: {},

  polizaFileNameSelected: { value: null, valid: false },
  tarjetaFileNameSelected: { value: null, valid: false },
  cedulaMercosurFileNameSelected: { value: null, valid: false },
  cuponeraFileNameSelected: { value: null, valid: false },
  isProcessingPoliza: false,
  isProcessingTarjeta: false,
  isProcessingCedulaMercosur: false,
  isProcessingCuponera: false,
  polizaActualizada: false,
  submitting: false,
  polizaValidaParaRenovacion: true,
  polizaRenovada: false,
  validatingPoliza: true,
};

const renovacionPolizaReducer = handleActions<RenovacionPolizaState, any>(
  {
    // [setInitialState]: (state, action) => {
    //   return {
    //     ...detallePolizaInitialState,
    //     take: state.take,
    //     polizas: null,
    //   };
    // },
    [setCurrentPoliza.toString()]: (
      state: RenovacionPolizaState,
      action: Action<any>
    ): RenovacionPolizaState => {
      return {
        ...state,
        currentUsuario: action.payload.currentUsuario,
      };
    },
    [getPolizaInited.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...renovacionPolizaInitialState,
        isLoading: true,
      };
    },
    [getPolizaCompleted.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ currentPoliza: GetPolizaResponse }>
    ): RenovacionPolizaState => {
      var vigencia = moment(
        action.payload.currentPoliza.datosPlan.polizaVigenciaHasta
      ).diff(
        moment(action.payload.currentPoliza.datosPlan.polizaVigenciaDesde),
        "months"
      );

      return {
        ...state,
        currentPoliza: action.payload.currentPoliza,
        isLoading: false,
        failed: false,
        vigenciaSelected: {
          value: vigencia,
          valid: true,
          focus: false,
        },
        vigenciaDesdeSelected: {
          value: moment(
            action.payload.currentPoliza.datosPlan.polizaVigenciaHasta
          ),
          valid: true,
          focus: false,
        },
        vigenciaHastaSelected: {
          value: moment(
            action.payload.currentPoliza.datosPlan.polizaVigenciaHasta
          ).add(vigencia, "months"),
          valid: true,
          focus: false,
        },
        cantidadCuotasSelected: {
          ...state.cantidadCuotasSelected,
          value:
            action.payload.currentPoliza.negocio === "Prendarios"
              ? 6
              : action.payload.currentPoliza.cantidadCuotas,
        },
        coberturaSelected: {
          value: action.payload.currentPoliza.coberturaId,
          valid: true,
          focus: false,
        },
      };
    },
    [getPolizaFailed.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
    [postRenovarPolizaInited.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [postRenovarPolizaCompleted.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        polizaRenovada: true,
        isLoading: false,
      };
    },
    [postRenovarPolizaFailed.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        isLoading: false,
      };
    },
    [postValidatePolizaInited.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        validatingPoliza: true,
      };
    },
    [postValidatePolizaCompleted.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        validatingPoliza: false,
        polizaValidaParaRenovacion: true,
      };
    },
    [postValidatePolizaFailed.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        polizaValidaParaRenovacion: false,
        validatingPoliza: false,
      };
    },
    [getCoberturasInited.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getCoberturasCompleted.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ coberturas: GetCoberturasCompaniaResponse }>
    ): RenovacionPolizaState => {
      let coberturasFilter = action.payload.coberturas.items.map(
        (cobertura) => ({
          label: `${cobertura.nombre} (Id ${cobertura.id})`,
          value: cobertura.id,
        })
      );

      let coberturasOptions = {};

      action.payload.coberturas.items.forEach((cobertura) => {
        coberturasOptions[cobertura.id] =
          `${cobertura.nombre} (Id ${cobertura.id})`;
      });

      return {
        ...state,
        isLoading: false,
        coberturasFilter,
        coberturasOptions,
      };
    },
    [getCoberturasFailed.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
    [setSubmitting.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ submitting: boolean }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        submitting: action.payload.submitting,
        premioTotalSelected: { ...state.premioTotalSelected, focus: false },
        numeroPolizaSelected: { ...state.numeroPolizaSelected, focus: false },
        vigenciaDesdeSelected: { ...state.vigenciaDesdeSelected, focus: false },
        vigenciaHastaSelected: { ...state.vigenciaHastaSelected, focus: false },
      };
    },
    [setVigenciaDesde.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{
        vigenciaDesdeSelected: CampoRenovacion<FechaRenovacion>;
      }>
    ): RenovacionPolizaState => {
      const vigenciaDesde = action.payload.vigenciaDesdeSelected;
      // `Date` toma también el moment que deja getPolizaCompleted, por su
      // valueOf, y el null del picker vacío.
      const vigenciaHasta = new Date(vigenciaDesde.value as unknown as Date);
      const vigencia = state.vigenciaSelected;

      return {
        ...state,
        vigenciaDesdeSelected: vigenciaDesde,
        vigenciaHastaSelected: {
          value: new Date(
            vigenciaHasta.setMonth(vigenciaHasta.getMonth() + vigencia.value)
          ),
          valid: true,
          focus: false,
        },
      };
    },
    [setVigenciaHasta.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{
        vigenciaHastaSelected: CampoRenovacion<FechaRenovacion>;
      }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        vigenciaHastaSelected: action.payload.vigenciaHastaSelected,
      };
    },
    [setVigencia.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ vigenciaSelected: CampoRenovacion<number> }>
    ): RenovacionPolizaState => {
      const vigencia = action.payload.vigenciaSelected;
      const vigenciaDesde = state.vigenciaDesdeSelected;
      return {
        ...state,
        vigenciaSelected: vigencia,
        vigenciaHastaSelected: {
          value: moment(vigenciaDesde.value).add(vigencia.value, "months"),
          valid: true,
          focus: false,
        },
      };
    },
    [setCantidadCuotas.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ cantidadCuotasSelected: CampoRenovacion<number> }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        cantidadCuotasSelected: action.payload.cantidadCuotasSelected,
      };
    },
    [setCobertura.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ coberturaSelected: CampoRenovacion<string> }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        coberturaSelected: action.payload.coberturaSelected,
      };
    },
    [setNumeroPoliza.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ numeroPolizaSelected: CampoRenovacion<string | null> }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        numeroPolizaSelected: action.payload.numeroPolizaSelected,
      };
    },
    [setPremioTotal.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{
        premioTotalSelected: CampoRenovacion<string | number | null>;
      }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        premioTotalSelected: action.payload.premioTotalSelected,
      };
    },
    [setSumaAsegurada.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{
        sumaAseguradaSelected: CampoRenovacion<string | number | null>;
      }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        sumaAseguradaSelected: action.payload.sumaAseguradaSelected,
      };
    },
    [setPolizaFileName.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ polizaFileNameSelected: CampoRenovacion<string | null> }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        polizaFileNameSelected: action.payload.polizaFileNameSelected,
      };
    },
    [setTarjetaFileName.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{
        tarjetaFileNameSelected: CampoRenovacion<string | null>;
      }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        tarjetaFileNameSelected: action.payload.tarjetaFileNameSelected,
      };
    },
    [setCedulaMercosurFileName.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{
        cedulaMercosurFileNameSelected: CampoRenovacion<string | null>;
      }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        cedulaMercosurFileNameSelected:
          action.payload.cedulaMercosurFileNameSelected,
      };
    },
    [setCuponeraFileName.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{
        cuponeraFileNameSelected: CampoRenovacion<string | null>;
      }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        cuponeraFileNameSelected: action.payload.cuponeraFileNameSelected,
      };
    },
    [setIsProcessingPoliza.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ isProcessingPoliza: boolean }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        isProcessingPoliza: action.payload.isProcessingPoliza,
      };
    },
    [setIsProcessingTarjeta.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ isProcessingTarjeta: boolean }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        isProcessingTarjeta: action.payload.isProcessingTarjeta,
      };
    },
    [setIsProcessingCedulaMercosur.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ isProcessingCedulaMercosur: boolean }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        isProcessingCedulaMercosur: action.payload.isProcessingCedulaMercosur,
      };
    },
    [setIsProcessingCuponera.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ isProcessingCuponera: boolean }>
    ): RenovacionPolizaState => {
      return {
        ...state,
        isProcessingCuponera: action.payload.isProcessingCuponera,
      };
    },
    [setCuota.toString()]: (
      state: RenovacionPolizaState,
      action: Action<{ cuotaSelected: CuotaRenovacion }>
    ): RenovacionPolizaState => {
      let id = action.payload.cuotaSelected.id;
      state.cuotasSelected[id] = action.payload.cuotaSelected;
      return {
        ...state,
        cuotasSelected: state.cuotasSelected,
      };
    },
    [clearCuotas.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...state,
        cuotasSelected: {},
      };
    },
    [clearData.toString()]: (
      state: RenovacionPolizaState
    ): RenovacionPolizaState => {
      return {
        ...renovacionPolizaInitialState,
      };
    },
  },

  renovacionPolizaInitialState
);

export { renovacionPolizaReducer };
export {
  getPoliza,
  //   setInitialState,
  setCurrentPoliza,
  setSubmitting,
  setVigencia,
  setVigenciaDesde,
  setVigenciaHasta,
  setCantidadCuotas,
  setNumeroPoliza,
  setPremioTotal,
  setSumaAsegurada,
  setPolizaFileName,
  setTarjetaFileName,
  setCedulaMercosurFileName,
  setCuponeraFileName,
  setIsProcessingPoliza,
  setIsProcessingTarjeta,
  setIsProcessingCedulaMercosur,
  setIsProcessingCuponera,
  postRenovarPoliza,
  getCoberturas,
  setCobertura,
  postValidatePoliza,
  setCuota,
  clearCuotas,
  clearData,
};
